export const environment = {
  production: true,
  appName: 'calculator',
  envName: 'acceptance',
  gmapsApiKey: 'AIzaSyCYMTLmXRw3cSB0_3MCfA0FQwXIHJGNT3U',
  legacyApi: {
    base: 'https://ops.acceptance.ygreneworks.com/api',
    host: 'https://ops.acceptance.ygreneworks.com',
  },
  sentryDsn: 'https://0144afb2ec5c471399b71cb599fe4810@sentry.io/2758430',
  datadog: {
    clientToken: 'pubae5bc319599b98b670f07941401fb2d2',
    applicationId: '4ffb191f-e108-4b3b-8dde-b0e872cfb479',
  },
  googleAnalyticsTrackingId: 'UA-99769428-16',
  hotjarSiteId: '1905853',
};
